<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Modifier un événement</p>
        </header>
        <section class="modal-card-body">
            <form method="POST">
                <input type="hidden" name="event" v-model="form.event">

                <!-- Date field -->
                <div class="columns" style="margin-bottom: 0;">
                    <div class="column is-half">
                        <b-field label="Date de début" :type="form.errors.has('started') ? 'is-danger' : ''" :message="form.errors.first('started')">
                            <b-input type="text" v-model="form.started" autofocus></b-input>
                        </b-field>
                    </div>
                    <div class="column is-half">
                        <b-field label="Date de fin" :type="form.errors.has('ended') ? 'is-danger' : ''" :message="form.errors.first('ended')">
                                    <b-input type="text" v-model="form.ended"></b-input>
                        </b-field>
                    </div>
                </div>

                <!-- Title field -->
                <b-field label="Titre de l'événement" :type="form.errors.has('title') ? 'is-danger' : ''" :message="form.errors.first('title')">
                    <b-input type="text" v-model="form.title" maxlength="100" has-counter></b-input>
                </b-field>

                <!-- Description field -->
                <b-field label="Description de l'événement" :type="form.errors.has('description') ? 'is-danger' : ''" :message="form.errors.first('description')">
                    <b-input type="textarea" v-model="form.description" @keydown.enter.native.prevent maxlength="1000" has-counter> </b-input>
                </b-field>

                <!-- Draft field -->
                <b-field v-if="user.id == event.author.id">
                    <b-switch v-model="draft" type="is-success">
                        Brouillon
                    </b-switch>
                </b-field>
            </form>
        </section>
        <footer class="modal-card-foot">
            <div class="field">
                <div class="control">
                    <button class="button is-primary" @click="submit()" :disabled="form.processing">
                        <i class="fa fa-spinner fa-pulse" v-show="form.processing"></i>
                        &nbsp;
                        <span>Enregistrer les modifications</span>
                    </button>
                    <button class="button" type="button" @click="$parent.close()">Annuler</button>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import format_date from '../mixins/date';
    import Form from 'form-backend-validation';

    export default {

        mixins: [format_date],

        props: ['event'],

        data() {
            return {
                draft: false,
                form: new Form({
                    event: 0,
                    started: '',
                    ended: '',
                    title: '',
                    description: '',
                    status: '',
                }),
            }
        },

        computed: {
            user() {
                return this.$store.state.account;
            }
        },

        watch: {
            draft: function (val) {
                this.form.status = (val == true) ? 'draft' : 'published';
            }
        },
    
        methods: {

            submit() {
                this.form.put('/api/v1/events/'+this.form.event)
                .then( response => {
                    this.$buefy.toast.open({
                        message: 'Vos modifications ont été enregistrées',
                        type: 'is-success'
                    });

                    Bus.$emit('event.fetch');
                    this.$parent.close();
                }).catch(response => {
                    this.$buefy.toast.open({
                        message: 'Une erreur s\'est produite',
                        type: 'is-danger'
                    });
                });
            },
        },

        created() {
            this.draft = (this.event.status == 'draft') ? true : false;
            this.form.populate({
                event: this.event.id,
                started: this.format_date(this.event.start),
                ended: this.format_date(this.event.end),
                title: this.event.title,
                description: this.event.description,
                status: this.event.status
            });
        }
    }
</script>